var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e-horizon-modal-header"},[_vm._t("default"),_vm._v(" "),_c('close-icon',{on:{"click":_vm.onClosed}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }